import { render, staticRenderFns } from "./Setup_BudgetsEdit.vue?vue&type=template&id=9c317f4a&"
import script from "./Setup_BudgetsEdit.vue?vue&type=script&lang=js&"
export * from "./Setup_BudgetsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports